import { useEffect } from 'react';
import { useSettings } from '../hooks/useApi';

const SEOHead = () => {
  const { data: settings } = useSettings();

  useEffect(() => {
    if (settings) {
      // Update document title
      document.title = `${settings.site_name} - Professional Software Development`;
      
      // Update meta description
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', settings.meta_description);
      }
      
      // Update other SEO meta tags if needed
      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords && settings.site_name) {
        const keywords = `software development, web development, React, Django, cloud computing, technology consulting, ${settings.site_name}`;
        metaKeywords.setAttribute('content', keywords);
      }
      
      // Update author meta tag
      const metaAuthor = document.querySelector('meta[name="author"]');
      if (metaAuthor && settings.site_name) {
        metaAuthor.setAttribute('content', settings.site_name);
      }
    }
  }, [settings]);

  return null; // This component doesn't render anything visual
};

export default SEOHead;